import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_ALL_QUALIFICATIONS = restRequest(
    "VRCORE.QUALIFICATIONS_MANAGER_V2.GET_ALL_QUALIFICATIONS"
);
export const GET_QUALIFICATION_CATEGORIES = restRequest(
    "VRCORE.QUALIFICATIONS_MANAGER_V2.GET_QUALIFICATION_CATEGORIES"
);
export const GET_REQUIRED_QUALIFICATIONS = restRequest(
    "VRCORE.QUALIFICATIONS_MANAGER_V2.GET_REQUIRED_QUALIFICATIONS"
);
export const SET_TABLE = "VRCORE.QUALIFICATIONS_MANAGER_V2.SET_TABLE";

export const SET_PAGE_INDEX = "VRCORE.QUALIFICATIONS_MANAGER_V2.SET_PAGE_INDEX";
export const SET_ROW_COUNT = "VRCORE.QUALIFICATIONS_MANAGER_V2.SET_ROW_COUNT";
export const SET_CATEGORY = "VRCORE.QUALIFICATIONS_MANAGER_V2.SET_CATEGORY";

export const ADD_QUALIFICATION = restRequest(
    "VRCORE.QUALIFICATIONS_MANAGER_V2.ADD_QUALIFICATION"
);
export const REMOVE_QUALIFICATION = restRequest(
    "VRCORE.QUALIFICATIONS_MANAGER_V2.REMOVE_QUALIFICATION"
);

export const GET_USERS = restRequest(
    "VRCORE.QUALIFICATIONS_MANAGER_V2.GET_USERS"
);
export const SET_SNACKBAR_STATE =
    "VRCORE.QUALIFICATIONS_MANAGER_V2.SET_SNACKBAR_STATE";
export const GET_CUSTOM_QUALIFICATONS = restRequest(
    "VRCORE.QUALIFICATIONS_MANAGER_V2.GET_CUSTOM_QUALIFICATIONS"
);
export const CREATE_CUSTOM_QUALIFICATION = restRequest(
    "VRCORE.QUALIFICATIONS_MANAGER_V2.CREATE_CUSTOM_QUALIFICATION"
);
export const EDIT_CUSTOM_QUALIFICATION = restRequest(
    "VRCORE.QUALIFICATIONS_MANAGER_V2.EDIT_CUSTOM_QUALIFICATION"
);
export const SET_VIEW_VALID_USERS_MODAL_INFO =
    "VRCORE.QUALIFICATIONS_MANAGER_V2.SET_VIEW_VALID_USERS_MODAL_INFO";

export const GET_DEPARTMENTS = restRequest("VRCORE.JOB_PACK_WIDGETS.JOB_PACK_ASSIGNEES_ARRAY_LIST.GET_DEPARTMENTS");
export const GET_AREAS = restRequest("VRCORE.JOB_PACK_WIDGETS.JOB_PACK_ASSIGNEES_ARRAY_LIST.GET_AREAS");
